import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../../theme'

const selectFromFileStyles: IStyles = {
    selectorWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 24,
        paddingLeft: 10,
        gap: 10,
        cursor: 'pointer',
    },
    selectorText: {
        marginLeft: 8,
        cursor: 'pointer',

        '&:hover': {
            color: colors.blueAccent,
        },
    },
    inProgress: {
        height: 16.5,
    },
    fileUploadLabel: {
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
    },
    uploaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.7)',
        zIndex: 10000,
    },
}

addStyles(selectFromFileStyles)
export default selectFromFileStyles
